import React       from "react";

function KirokuButton(props){
        return (
            <button {...props} className={`${props.className} btn btn-kiroku-` + props.color}>{props.children}</button>
        )
}

export default KirokuButton;
